<template>
<div class="section">
    <div class="title-box" v-if="title">
      <div class="title-bg"><span></span></div>
      <div class="title" @click="handleTitleClick('https://www.youtube.com/watch?v=xm5cevHVnrU')">
        <div class="title-text MF_1">
        <img class="star-a" src="@/assets/images/star-a.svg" alt="star" srcset=""> 
        {{ title }}
        <img class="star-b" src="@/assets/images/star-a.svg" alt="star" srcset="">
        </div>
      </div>
    </div>
    <div class="content">
    <div class="bot-bg"></div>
    <div id="video">
        <div class="img-list">
        <div style="width: 100%;">
            <div class="video-wrapper" 
            @click="handlePlay( videoList[0].type, videoList[0].url)"
            :style="{ height: `${getVideoHeight(videoList[0].url)}px` }"
            >
            <!-- <div class="video-mask" v-if="!isPlay">
                <img class="video-img" :src="videoList[0].image" alt="img" />
                <img class="video-play" src="https://frontend-resource.jihuanshe.com/market/play_video.png" alt="play" />
            </div> -->
            <template v-if="!isPlay">
                <!-- @pause="handlePause"
                @ended="handleEnded" -->
                <video 
                v-if="videoList[0].type === 'VIDEO'  && !needsIframe(videoList[0].url)"
                ref="videoRef"
                class="video-content" 
                :src="videoList[0].url" 
                controls
                ></video>
                <iframe
                v-else-if="needsIframe(videoList[0].url)"
                class="video-content"
                :src="getVideoIframeSrc(videoList[0].url)"
                scrolling="no"
                border="0"
                frameborder="no"
                framespacing="0"
                allowfullscreen="true"
                sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
                referrerpolicy="no-referrer"
                loading="lazy"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                @load="setupIframeListener"
                ref="iframeRef"
                ></iframe>
                <!-- <div 
                v-else-if="videoList[0].type === 'VIDEO' && getVideoPlatform(videoList[0].url) === 'douyin'"
                class="video-content loading-container"
                >
                <div v-if="isLoading" class="loading-text">视频加载中...</div>
                <div v-else-if="errorMessage" class="error-text">{{ errorMessage }}</div>
                <div v-else-if="!videoUrl" class="error-text">无法加载视频</div>
                </div> -->
            </template>
            </div>
            <div v-if="videoList[0].remark" class="video-text CH_6_Regular" @click="handleTitleClick('https://www.tiktok.com/@_jenniferbeckham/live')">{{ videoList[0].remark }}</div>
        </div>
        </div>
    </div>
    </div>
</div>
</template>

<script setup lang="ts">
import { ref, nextTick, onMounted } from 'vue';
import { track } from '@/utils/tracking';
import { showConfirmDialog } from 'vant';
import { useI18n } from 'vue-i18n';
const { t }: { t: (key: string) => string } = useI18n();
import path from 'path';

const PLATFORM_MAP: Record<string, string> = {
  bilibili: '哔哩哔哩',
  douyin: '抖音',
  youtube: 'YouTube',
  tiktok: 'TikTok',
  '': '外部链接'
};

interface VideoItem {
type: 'VIDEO' | 'LIVE';
title: string;
link?: string;
url?: string;
image?: string;
remark?: string;
}

const props = defineProps<{
videoList: VideoItem[];
title: string;
module_ID: string;
}>();

const isPlay = ref(false);
const videoRef = ref<HTMLVideoElement | null>(null);
const iframeRef = ref<HTMLIFrameElement | null>(null);
const videoUrl = ref<string>('');
const isLoading = ref(false);
const errorMessage = ref('');

// 解析抖音视频
const parseDouyinVideo = async (url: string) => {
isLoading.value = true;
errorMessage.value = '';

try {
    // 使用抖音视频解析API
    const response = await fetch(`https://api.douyin.wtf/api?url=${encodeURIComponent(url)}`);
    const data = await response.json();
    
    if (data.status === 'success' && data.video_url) {
    videoUrl.value = data.video_url;
    } else {
    errorMessage.value = data.message || '视频解析失败';
    console.error('视频解析失败:', data.message);
    }
} catch (error) {
    errorMessage.value = '视频解析出错，请稍后重试';
    console.error('视频解析出错:', error);
} finally {
    isLoading.value = false;
}
}

// 判断视频平台类型
const getVideoPlatform = (url?: string) => {
if (!url) return '';
if (url.includes('bilibili.com/')) return 'bilibili';
if (url.includes('douyin.com/') || url.includes('v.douyin.com/')) return 'douyin';
if (url.includes('youtube.com/') || url.includes('youtu.be/')) return 'youtube';
if (url.includes('tiktok.com/')) return 'tiktok';
return '';
}

// 获取视频iframe的src
const getVideoIframeSrc = (url?: string) => {
if (!url) return '';

const platform = getVideoPlatform(url);

switch (platform) {
    case 'bilibili':
    // 匹配视频BV号或直播房间号
    const bvidMatch = url.match(/BV\w+/);
    const liveMatch = url.match(/live\.bilibili\.com\/(\d+)/);
    
    if (bvidMatch) {
      return `https://player.bilibili.com/player.html?bvid=${bvidMatch[0]}&page=1&high_quality=1&danmaku=0&autoplay=0&show_progress=1&show_control=1`;
    } else if (liveMatch) {
      return `https://live.bilibili.com/${liveMatch[1]}?display=1&autoplay=0`;
    }
    return '';
    
    case 'douyin':
    // 处理抖音分享链接
    let douyinId = '';
    if (url.includes('v.douyin.com/')) {
        // 处理短链接
        const shortCode = url.match(/v\.douyin\.com\/(\w+)/)?.[1];
        if (shortCode) {
        douyinId = shortCode;
        }
    } else {
        // 处理普通链接
        const douyinMatch = url.match(/video\/(\d+)/);
        if (douyinMatch) {
        douyinId = douyinMatch[1];
        }
    }
    if (!douyinId) return '';
    // return `https://www.douyin.com/embed/${douyinId}`;
    return `https://open.douyin.com/player/video?vid=${douyinId}`;
    
    case 'youtube':
    let videoId = '';
    if (url.includes('youtube.com/watch')) {
        const urlParams = new URLSearchParams(new URL(url).search);
        videoId = urlParams.get('v') || '';
    } else if (url.includes('youtu.be/')) {
        videoId = url.split('youtu.be/')[1];
    }
    if (!videoId) return '';
    return `https://www.youtube.com/embed/${videoId}?autoplay=0&rel=0`;
    
    case 'tiktok':
    const tiktokMatch = url.match(/video\/(\d+)/);
    if (!tiktokMatch) return '';
    // return `https://www.tiktok.com/embed/${tiktokMatch[1]}`;
        return `https://www.tiktok.com/static/profile-video?id=${tiktokMatch[1]}`;
    
    default:
    return '';
}
}

// 判断是否需要使用iframe嵌入
const needsIframe = (url?: string) => {
if (!url) return false;
return ['bilibili', 'douyin', 'youtube', 'tiktok'].includes(getVideoPlatform(url));
}

// 获取视频容器高度
const getVideoHeight = (url?: string) => {
console.log(url, '当前url');
const platform = getVideoPlatform(url);
if (platform === 'douyin' || platform === 'tiktok') {
    return 703;
}
return 196; // 默认高度
}

// 组件挂载时解析抖音视频
onMounted(() => {
// console.log('videoList:', props.videoList);
if (props.videoList[0]?.url && getVideoPlatform(props.videoList[0].url) === 'douyin') {
    parseDouyinVideo(props.videoList[0].url);
}
});

// 暂停
// const handlePause = () => {
//   isPlay.value = false;
// }

// // 结束
// const handleEnded = () => {
//   isPlay.value = false;
// }

// 设置iframe点击监听
const setupIframeListener = () => {
  if (!iframeRef.value || !props.videoList[0]) return;
  
  try {
    // 尝试为iframe添加点击事件监听
    const iframe = iframeRef.value;
    
    // 视频类型不需要覆盖层，直接让iframe处理播放
    if (props.videoList[0].type === 'VIDEO') {
      return;
    }
    
    // 只有直播类型才需要覆盖层来处理跳转
    if (props.videoList[0].type === 'LIVE') {
      // 创建一个透明覆盖层来捕获点击事件
      const overlay = document.createElement('div');
      overlay.style.position = 'absolute';
      overlay.style.top = '0';
      overlay.style.left = '0';
      overlay.style.width = '100%';
      overlay.style.height = '100%';
      overlay.style.zIndex = '10';
      overlay.style.cursor = 'pointer';
      
      // 添加点击事件处理
      overlay.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        
        // 直播类型 - 调用跳转方法
        if (props.videoList[0].url) {
          handleTitleClick(props.videoList[0].url);
        }
      });
      
      // 将覆盖层添加到iframe的父元素
      if (iframe.parentNode) {
        iframe.parentNode.appendChild(overlay);
      }
    }
  } catch (error) {
    console.error('设置iframe监听失败:', error);
  }
};

const handlePlay = (type: string, url?: string) => {
    track('H5Landing_module_operation', {
        operation: 'click_on_link_video',
    });
    track('lst_H5Landing_module_video', {
        module_ID: props.module_ID,
        module_type: 'link_video',
        link_video: {
            path: url,
            name: props.title,
            channel: getVideoPlatform(url),
        },
    });
if (!url) return;

if (type === 'VIDEO') {
    // 视频类型
    const platform = getVideoPlatform(url);
    if (needsIframe(url)) {
      // 对于使用iframe的视频，不需要额外处理，让iframe自己处理播放
      return;
    }
    // 对于原生video标签，可以直接控制播放
    if (videoRef.value) {
      videoRef.value.play();
      isPlay.value = true;
    }
} else if (type === 'LIVE') {
    // 直播类型跳转
    handleTitleClick(url);
}
}

const handleTitleClick = async (url: string) => {
    // 获取平台类型
    const platform = getVideoPlatform(url);
    console.log(platform, '当前平台');
    console.log(localStorage.getItem('user_lang'), '当前语言');
    const lang = localStorage.getItem('user_lang');

    // 使用showConfirmDialog函数显示确认框
    try {
      await showConfirmDialog({
        message: lang === 'sc' ? `是否前往${PLATFORM_MAP[platform] || ''}观看？` : `${PLATFORM_MAP[platform] || ''}で視聴しますか？`,
        confirmButtonText: t('common.confirm'),
        cancelButtonText: t('common.cancel'),
        confirmButtonColor: '#1F1F1D',
        cancelButtonColor: '#666666',
      });
    } catch (e) {
      return; // 用户点击取消
    }

    // 检测是否在APP内
    const isInApp = window.jhsapp;
    
    // 根据不同平台处理跳转
    if (isInApp) {
        // APP内打开使用deeplink
        if (platform === 'douyin') {
            // 抖音deeplink
            let roomId;
            if (url.includes('live.douyin.com')) {
                roomId = url.match(/live\.douyin\.com\/(\d+)/)?.[1];
            } else if (url.includes('v.douyin.com')) {
                // 处理短链接格式
                const shortId = url.split('/').pop();
                window.location.href = `snssdk1128://webview?url=${encodeURIComponent(url)}`;
                return;
            }
            console.log(roomId, '当前是douyin');
            if (roomId) {
                window.location.href = `snssdk1128://live?room_id=${roomId}`;
            }
        } else if (platform === 'bilibili') {
            // B站deeplink
            const roomId = url.match(/live\.bilibili\.com\/(\d+)/)?.[1];
            console.log(roomId, '当前是bilibili', `bilibili://live/${roomId}`);
            if (roomId) {
                // window.location.href = `bilibili://live/${roomId}`;
                // 创建一个隐藏的iframe来检测应用是否安装
                const iframe = document.createElement('iframe');
                iframe.style.display = 'none';
                document.body.appendChild(iframe);
                
                let appInstalled = false;
                
                // 监听页面可见性变化
                const visibilityHandler = () => {
                    if (document.hidden) {
                        appInstalled = true;
                        document.body.removeChild(iframe);
                        document.removeEventListener('visibilitychange', visibilityHandler);
                    }
                };
                
                document.addEventListener('visibilitychange', visibilityHandler);
                
                // 尝试打开应用
                iframe.src = `bilibili://live/${roomId}`;
                
                // 设置超时检测
                setTimeout(() => {
                    if (!appInstalled) {
                        // 移除监听器和iframe
                        document.removeEventListener('visibilitychange', visibilityHandler);
                        document.body.removeChild(iframe);
                        
                        // 显示未安装提示
                        window.open(url, '_blank');
                    }
                }, 2000);
            }
        } else if (platform === 'tiktok') {
            // TikTok deeplink
            const username = url.match(/@[\w._-]+\/live/)?.[0]?.replace('@', '')?.replace('/live', '');
            console.log(username, '当前是tiktok');
            if (username) {
                // 尝试多种TikTok deeplink格式
                const tiktokLinks = [
                    `tiktok://user/@${username}`,
                    `tiktok://user/${username}`,
                    `tiktok://@${username}`,
                    `tiktok://${username}`
                ];
                
                // 创建一个隐藏的iframe来检测应用是否安装
                const iframe = document.createElement('iframe');
                iframe.style.display = 'none';
                document.body.appendChild(iframe);
                
                let appInstalled = false;
                let currentIndex = 0;
                
                const tryNextLink = () => {
                    if (currentIndex >= tiktokLinks.length) {
                        console.log('所有deeplink都失败，跳转到网页版', url);
                        // 所有deeplink都失败，跳转到网页版
                        window.open(url, '_blank');
                        document.body.removeChild(iframe);
                        return;
                    }
                    
                    iframe.src = tiktokLinks[currentIndex];
                    currentIndex++;
                    
                    // 设置超时，如果一段时间后还在当前页面，说明应用未安装
                    setTimeout(() => {
                        if (!appInstalled) {
                            tryNextLink();
                        }
                    }, 1000);
                };
                
                // 监听页面可见性变化
                document.addEventListener('visibilitychange', () => {
                    if (document.hidden) {
                        appInstalled = true;
                        document.body.removeChild(iframe);
                    }
                });
                
                tryNextLink();
            }
        } else if (platform === 'youtube') {
            // YouTube deeplink
            const videoId = url.match(/watch\?v=([^&]+)/)?.[1];
            console.log(videoId, '当前是youtube');
            if (videoId) {
                // 尝试多种YouTube deeplink格式
                const youtubeLinks = [
                    `vnd.youtube://${videoId}`,
                    `youtube://${videoId}`,
                    `youtube://watch?v=${videoId}`
                ];
                
                // 创建一个隐藏的iframe来检测应用是否安装
                const iframe = document.createElement('iframe');
                iframe.style.display = 'none';
                document.body.appendChild(iframe);
                
                let appInstalled = false;
                let currentIndex = 0;
                
                const tryNextLink = () => {
                    if (currentIndex >= youtubeLinks.length) {
                        console.log('所有deeplink都失败，跳转到网页版', url);
                        // 所有deeplink都失败，跳转到网页版
                        window.open(url, '_blank');
                        document.body.removeChild(iframe);
                        return;
                    }
                    
                    iframe.src = youtubeLinks[currentIndex];
                    currentIndex++;
                    
                    // 设置超时，如果一段时间后还在当前页面，说明应用未安装
                    setTimeout(() => {
                        if (!appInstalled) {
                            tryNextLink();
                        }
                    }, 1000);
                };
                
                // 监听页面可见性变化
                document.addEventListener('visibilitychange', () => {
                    if (document.hidden) {
                        appInstalled = true;
                        document.body.removeChild(iframe);
                    }
                });
                
                tryNextLink();
            }
        }
    } else {
        // 浏览器中直接打开网页版
        window.open(url, '_blank');
    }
}

</script>

<style lang="scss" scoped>
@import '@/styles/section.scss';

:deep(.custom-dialog) {
  border-radius: 12px !important;
  overflow: hidden;
  
  .van-dialog__header {
    padding: 20px 20px 10px;
    font-weight: 600;
    font-size: 16px;
    color: var(--on-container-text-primary);
  }
  
  .van-dialog__message {
    padding: 16px 20px;
    font-size: 14px;
    color: var(--on-container-text-secondary);
  }
  
  .van-dialog__footer {
    padding: 8px 12px 16px;
    
    .van-button {
      height: 36px;
      border-radius: 18px;
      font-size: 14px;
      
      &--default {
        border-color: #ebedf0;
        color: #666666;
      }
      
      &--primary {
        background: var(--container-surface-dark);
        border: none;
      }
    }
  }
}

#video {
width: 100%;
.img-list {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .video-text {
    color: var(--on-container-text-secondary);
    margin-top: var(--gap-7);
    word-break: break-all;
    white-space: pre-wrap;
    }

    .video-wrapper {
    width: 100%;
    // aspect-ratio: 16/9;
    position: relative;
    border-radius: 12px;
    overflow: hidden;
    height: 196px;

    .video-mask {
        position: relative;
        z-index: 2;
        width: 100%;
        height: 100%;
    }

    .video-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 12px;
    }

    .video-play {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 60px;
        height: 60px;
    }

    .video-content {
        width: 100%;
        height: 100%;
        border-radius: 12px;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
    }

    .douyin-container {
        position: relative;
        width: 100%;
        height: 100%;
        overflow: hidden;
    }

    iframe.video-content {
        border: none;
        width: 100%;
        height: 100%;
    }
    }
}
}

.loading-container {
display: flex;
align-items: center;
justify-content: center;
background: #000;

.loading-text {
    color: #fff;
    font-size: 14px;
}

.error-text {
    color: #ff4d4f;
    font-size: 14px;
    text-align: center;
    padding: 0 20px;
}
}
</style> 